// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3r18E","row":"ProcedureTreatmentSummary_row__9rhdS"};